import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveTo24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMoveTo24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 2.5A1.5 1.5 0 0 0 4.5 4v2A1.5 1.5 0 0 0 6 7.5h3.25a1.5 1.5 0 0 0 1.5-1.5V4a1.5 1.5 0 0 0-1.5-1.5zM6 4h3.25v2H6zm0 5.5A1.5 1.5 0 0 0 4.5 11v2A1.5 1.5 0 0 0 6 14.5h3.25a1.5 1.5 0 0 0 1.5-1.5v-2a1.5 1.5 0 0 0-1.5-1.5zM6 11h3.25v2H6zm-1.5 7A1.5 1.5 0 0 1 6 16.5h3.25a1.5 1.5 0 0 1 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 20zm4.75 0H6v2h3.25zM13 9.25a.75.75 0 0 0 1.5 0V6.956A6 6 0 0 1 17.25 12a6 6 0 0 1-2.75 5.045V14.75a.75.75 0 0 0-1.5 0v4.75h4.75a.75.75 0 0 0 0-1.5h-1.999a7.49 7.49 0 0 0 2.999-6 7.49 7.49 0 0 0-3-6h2a.75.75 0 0 0 0-1.5H13z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoveTo24);
